import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const selectorRequirementEngagementsSize = (
  requirement: PayeeRequirement
) => {
  return requirement.payeeEngagementIds?.length || 1;
};
